import generalUpload from "../_section/upload.class";
import dayjs from "dayjs";

export class userHTBSchemeFormsUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [
        {
            name: 'documentDate',
            label: 'Document Date',
            type: 'date',
            optional: true,
        },
        {
            name: 'accessCode',
            label: 'Access Code',
            type: 'text',
            optional: true,
        },
        {
            name: 'applicationCode',
            label: 'Application Code',
            type: 'text',
            optional: true,
        }, {
            name: 'amount',
            label: 'Amount',
            type: 'currency',
            optional: true,
        },
        {
            name: 'expiryDate',
            label: 'Expiry Date',
            type: 'date',
            optional: true,
        }
    ]
}

export class adminHTBSchemeFormsUpload extends userHTBSchemeFormsUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)

            this.setDateData({
                dated: this.values.documentDate || dayjs(),
                expires: this.values.expiryDate,
            })

    }
}
